module.exports = __webpack_public_path__ + "img/dashboard-placeholder.b2d590c3.png";